import * as React from 'react';
import Envelope from 'src/images/dashboard/envelope.svg';

import useI18n from 'src/hooks/useI18n';

import css from './dashboard.css';


function EmptyDashboard({agentName}: {agentName: string}) {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  return (
    <div className={css.emptyDashboard} data-qa-id="dashboard">
      <div className={css.emptyDashboardContent} data-it-dashboard-empty>
        <h1 className={css.emptyDashboardGreeting}>{`${t(
          'Hi',
          'Hi',
        )}, ${agentName}`}</h1>
        <Envelope className={css.envelope} />
        <h2 className={css.emptyDashboardSubheader}>
          {t('Welcome_to_Sense', 'Welcome to Sense')}
        </h2>
        <p className={css.emptyDashboardIntro}>
          {t(
            'Start_browsing_through_the_navigation_to_the_left',
            'Start browsing through the navigation to the left.',
          )}
        </p>
      </div>
    </div>
  );
}

export default EmptyDashboard;
